import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { select, Store } from '@ngrx/store';
import { RootState } from '../../store/store.state';
import { selectDowndloadInfo } from '../store/utils.selectors';

@Component({
    selector: 'q-download',
    templateUrl: './download.component.html',
    styleUrls: ['./download.component.scss']
})
export class DownloadComponent implements OnInit {
    downloadInfo$: Observable<{ fileName: string; url: string }>;

    constructor(private store: Store<RootState>) {
        this.downloadInfo$ = this.store.pipe(select(selectDowndloadInfo));
    }

    ngOnInit() {
        this.downloadInfo$.subscribe(downloadInfo => {
            if (downloadInfo.url.length > 0) {
                console.log('downloadURL: ' + downloadInfo.url);
                let a = document.createElement('a');
                a.style.display = 'none';
                document.body.appendChild(a);
                a.href = downloadInfo.url.toString();
                a.download = downloadInfo.fileName;
                a.click();
                document.body.removeChild(a);

                // Clean up resources for JS download
                window.URL.revokeObjectURL(downloadInfo.url.toString());
            }
        });
    }
}
